import { createFileRoute, Link } from "@tanstack/react-router";
import { useSEO } from "../hooks/useSEO";
import { SEO_CONFIG, SITE_ORIGIN } from "../seo/seoConfig";
import { JsonLd } from "../seo/JsonLd";
import { profilePageSchema } from "../seo/schemas";
import { AuthorAvatar } from "../components/about/AuthorAvatar";
import { CALIN, realLinks } from "../data/authors";

export const Route = createFileRoute("/about")({
  component: AboutPage,
});

function AboutPage() {
  useSEO(SEO_CONFIG["/about"]!);
  const author = CALIN;
  const links = realLinks(author);

  return (
    <div className="min-h-screen bg-white">
      <JsonLd
        data={profilePageSchema({
          name: author.name,
          description: author.bio,
          url: `${SITE_ORIGIN}/about`,
          knowsAbout: author.knowsAbout,
          ...(links.length > 0 ? { sameAs: links.map((l) => l.url) } : {}),
        })}
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:py-16">
        <header className="mb-8 flex items-center gap-5">
          <AuthorAvatar name={author.name} photo={author.photo} size={88} />
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-foreground">{author.name}</h1>
            <p className="mt-1 text-lg text-foreground/70">{author.title}</p>
          </div>
        </header>

        <div className="space-y-4 text-[17px] leading-relaxed text-foreground/90">
          {author.story.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>

        <section className="mt-8" aria-labelledby="expertise-heading">
          <h2 id="expertise-heading" className="mb-2 text-sm font-semibold uppercase tracking-wide text-muted-foreground">
            Areas of expertise
          </h2>
          <ul className="flex flex-wrap gap-2">
            {author.knowsAbout.map((topic) => (
              <li key={topic} className="rounded-full border-[0.5px] border-input px-3 py-1 text-sm text-foreground/80">
                {topic}
              </li>
            ))}
          </ul>
        </section>

        {links.length > 0 && (
          <section className="mt-8" aria-labelledby="links-heading">
            <h2 id="links-heading" className="mb-2 text-sm font-semibold uppercase tracking-wide text-muted-foreground">
              Elsewhere
            </h2>
            <ul className="flex flex-wrap gap-4">
              {links.map((l) => (
                <li key={l.url}>
                  <a
                    href={l.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand underline underline-offset-2 hover:text-brand/80"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}

        <div className="mt-10 border-t-[0.5px] border-input pt-6">
          <Link to="/" className="text-brand hover:underline">
            ← Back to ProvenLeap
          </Link>
        </div>
      </div>
    </div>
  );
}
